export const CAMPAIGNS_REDUCER_NAME = 'campaigns'
export const CAMPAIGNS_ITEMS_REDUCER_NAME = 'items'
export const CAMPAIGN_DETAILS_REDUCER_NAME = 'details'
export const CAMPAIGN_PRODUCTS_REDUCER_NAME = 'products'
